export default "__VITE_ASSET__vQf3MuH5__"